(function () {
  let stylesheetInjected = false;
  const STYLESHEET_ID = 'cart-drawer-payment-terms-styles';
  const MAX_CHECK_DURATION = 5000;
  const CHECK_INTERVAL = 100;
  /** @type {number | null} */
  let startTime = null;
  /** @type {ReturnType<typeof setInterval> | null} */
  let intervalId = null;

  function injectStylesheet() {
    const paymentTermsElements = document.querySelectorAll('shopify-payment-terms');
    if (!paymentTermsElements || paymentTermsElements.length === 0) return false;

    let injected = false;
    paymentTermsElements.forEach((paymentTerms) => {
      const shadowRoot = paymentTerms.shadowRoot;
      if (!shadowRoot) return;

      const existingStylesheet = shadowRoot.getElementById(STYLESHEET_ID);
      if (existingStylesheet) {
        injected = true;
        return;
      }

      // Check if the element is within a .installments container
      const isInInstallments = paymentTerms.closest('.installments') !== null;
      const fontSize = isInInstallments ? '11px' : '14px';

      const style = document.createElement('style');
      style.id = STYLESHEET_ID;
      style.textContent = `
      #shopify-installments *:not(.text-purple-primary, svg, path) {
        font-family: 'Poppins', sans-serif !important;
        font-size: ${fontSize} !important;
        color: rgba(0, 0, 0, 0.7) !important;
      }
    `;
      shadowRoot.appendChild(style);
      injected = true;
    });

    return injected;
  }

  function checkForPaymentTerms() {
    if (!startTime) return;

    const elapsed = Date.now() - startTime;

    if (elapsed >= MAX_CHECK_DURATION) {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
      return;
    }

    const injected = injectStylesheet();

    if (injected && intervalId) {
      clearInterval(intervalId);
      intervalId = null;
      stylesheetInjected = true;
    }
  }

  function init() {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }

    stylesheetInjected = false;
    startTime = Date.now();

    const injected = injectStylesheet();
    if (injected) {
      stylesheetInjected = true;
      return;
    }

    customElements
      .whenDefined('shopify-payment-terms')
      .then(() => {
        const injected = injectStylesheet();
        if (injected) {
          stylesheetInjected = true;
        } else if (!intervalId) {
          intervalId = setInterval(checkForPaymentTerms, CHECK_INTERVAL);
        }
      })
      .catch(() => {
        if (!intervalId) {
          intervalId = setInterval(checkForPaymentTerms, CHECK_INTERVAL);
        }
      });
  }

  function handleCartUpdate() {
    setTimeout(() => {
      init();
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('cart:update', handleCartUpdate);
})();
